import { gtagEvent } from "@stadium/services/google-analytics";

const ORDER_TYPE = "Recipient_order";

const useAnalyticsActionEvents = () => {
  const trackShopPreview = (eventObj = {}) => {
    const { shop_id, shop_name } = eventObj;
    const eventName = "Preview Shop";
    gtagEvent(eventName, { shop_id, shop_name });
  };

  const trackShopRedemption = (eventObj = {}) => {
    const { transaction_id, value, currency, shop_id, payment_methods } = eventObj;
    const eventName = "purchase";
    gtagEvent(eventName, {
      transaction_id,
      order_type: ORDER_TYPE,
      value,
      currency,
      shop_id,
      payment_methods,
    });
  };

  return {
    trackShopPreview,
    trackShopRedemption,
  };
};

export default useAnalyticsActionEvents;
